// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3E_dP","messages":"Chat_messages__1dqww","dateDivider":"Chat_dateDivider__31NN4"};